import { useLocation } from '@xing-com/crate-core-router';

export const useIsCoverLetterEditor = (): boolean => {
  const { pathname } = useLocation();

  return pathname.includes('anschreiben') || pathname.includes('cover_letter');
};
